var map = {
	"./adult/de/2 2 Ordkjedetest-her-ser-du-4-ovingsoppgaver.mp3": 765,
	"./adult/nn/2 2 Ordkjedetest-her-ser-du-4-ovingsoppgaver.mp3": 766,
	"./adult/no/2 2 Ordkjedetest-her-ser-du-4-ovingsoppgaver.mp3": 767,
	"./youth/de/2 2 Ordkjedetest-her-ser-du-4-ovingsoppgaver.mp3": 768,
	"./youth/nn/2 2 Ordkjedetest-her-ser-du-4-ovingsoppgaver.mp3": 769,
	"./youth/no/2 2 Ordkjedetest-her-ser-du-4-ovingsoppgaver.mp3": 770,
	"./youth/se/2 2 Ordkjedetest-her-ser-du-4-ovingsoppgaver.mp3": 771
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 764;